import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedAssinaturasData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/assinaturas?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllAssinaturasData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/assinaturas?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.identificadorEmpresa}"`,
    `"${data.empresa}"`,
    `"${data.tipoAssinatura}"`,
    `"${toDate(data.dataHoraCompra)}"`,
    `"${toDate(data.expiraEm)}"`,
    `"${data.finalPeriodoGratuito}"`,
    `"${data.status}"`,
    data.plataforma != null ? `"${data.plataforma}"` : '',
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataHoraCompraInicial: toDateFromPtBr(options.creationInitialDate),
  dataHoraCompraFinal: toDateFromPtBr(options.creationEndDate),
  expiraEmInicial: toDateFromPtBr(options.closingInitialDate),
  expiraEmFinal: toDateFromPtBr(options.closingEndDate),
  finalPeriodoGratuitoInicial: toDateFromPtBr(options.freeInitialDate),
  finalPeriodoGratuitoFinal: toDateFromPtBr(options.freeEndDate),
  status: options.status,
});

export const getEmpresasIndicadores = async(options) => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`empresas/identificadores?${new URLSearchParams(options).toString()}`);
  return response.data;
};
export const getNomesAssinaturas = async() => {
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get('planosAssinatura/nomes');
  return response.data;
};
export const addAssinatura = async(assinatura) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.post('assinatura/avulsa', assinatura);
    return true;
  } catch (error) {
    if (error.response.status === 400) return error.response.data.validation.body.message;
    throw error;
  }
};
